import styles from '../styles/header.module.css'

const Header = () => {
  return (
    <div className={styles.container}>
      <h4>오늘도 좋은 하루되세요😎</h4>
    </div>
  )
}

export default Header